import { motion } from "framer-motion";
import HairJournal from "../components/features/HairJournal";

export default function HairJournalPage() {
  return (
    <div className="bg-gray-50 pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-serif font-bold text-primary-900 mb-4">
            Your Hair Journey
          </h1>
          <p className="text-lg text-gray-600">
            Track your hair care progress and maintain a record of your routines
            and favorite products.
          </p>
        </motion.div>

        <HairJournal />
      </div>
    </div>
  );
} 